import GenerateAPI from '../generate.js'


const config = {
    list: {
        url: '/client/refund/list',
        apiType: 'check',
    }
}

const apiPayRefund = GenerateAPI.generate(config)

export default apiPayRefund
